export function ContentCardItem({ children }) {
  return children;
}
